import React from 'react';
import { StyleSheet, View } from 'react-native';
import Button from 'src/components/10-atoms/button/Button';
import HTMLRenderer from 'src/components/10-atoms/form/inputs/editor/html/HTMLEditor/Renderer';
import Label from 'src/components/10-atoms/form/Label';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import Typography from 'src/components/10-atoms/typography/Typography';
import { TypographyFontWeight, TypographyVariant, } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
const EFView = ({ questionPaper, examinersFeedback, isLast, isFirst, isCurrent, style, onEdit, onAdd, isEditLoading = false, isAddLoading = false, ...colProps }) => {
    const [{ styles, theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    return (React.createElement(Column, { style: [styles.container, style], ...colProps },
        React.createElement(Column, { style: [styles.innerContainer, isLast && styles.lastContainer] },
            React.createElement(Column, { style: styles.timelineContainer },
                React.createElement(Column, { style: [
                        styles.timelineTop,
                        isFirst && { backgroundColor: theme.palette.background.main }
                    ] }),
                !isLast && React.createElement(Column, { flex: true, style: styles.timelineBottom }),
                React.createElement(View, { style: [styles.marker, isCurrent && { backgroundColor: theme.palette.background.positive, transform: [{ scale: 1.4 }] }] })),
            examinersFeedback ? (React.createElement(Column, { style: styles.contentContainer },
                React.createElement(Row, { xAxis: 'space-between', yAxis: 'center' },
                    React.createElement(Label, { fontWeight: isCurrent
                            ? TypographyFontWeight.MEDIUM
                            : TypographyFontWeight.REGULAR }, questionPaper.data.label),
                    React.createElement(Button, { variant: "text", LeftIcon: props => React.createElement(FeatherIcon, { name: "edit-2", ...props }), onPress: onEdit, size: 'xs', loading: isEditLoading })),
                React.createElement(HTMLRenderer, { html: examinersFeedback.data.feedback }))) : (React.createElement(Column, { style: styles.contentContainer },
                React.createElement(Row, { xAxis: 'space-between', yAxis: 'center' },
                    React.createElement(Column, { flex: true },
                        React.createElement(Label, { fontWeight: isCurrent
                                ? TypographyFontWeight.MEDIUM
                                : TypographyFontWeight.REGULAR }, `${questionPaper.data.label}${isCurrent ? translate(' (Current)') : ''}`),
                        React.createElement(Typography, { variant: TypographyVariant.CAPTION, color: theme.palette.typography.secondary }, translate("Examiners Feedback is missing"))),
                    React.createElement(Button, { variant: "outline", onPress: onAdd, size: 'xs', LeftIcon: props => React.createElement(FeatherIcon, { name: "plus", ...props }), loading: isAddLoading }, translate('Feedback'))))))));
};
const MARKER_SIZE = 12;
const stylesGenerator = createThemedStyle(({ theme }) => ({
    container: {
        paddingLeft: theme.spacing.standard.md,
    },
    contentContainer: {
        padding: theme.spacing.standard.sm,
        borderRadius: theme.borderRadius.standard.lg,
        backgroundColor: theme.palette.background.subtle,
    },
    innerContainer: {
        paddingLeft: theme.spacing.standard.md,
        paddingBottom: theme.spacing.itemSeparation,
    },
    lastContainer: {
        borderLeftWidth: 0,
    },
    marker: {
        position: 'absolute',
        top: 18,
        left: -(MARKER_SIZE / 2),
        width: MARKER_SIZE,
        height: MARKER_SIZE,
        borderRadius: MARKER_SIZE,
        borderWidth: 2,
        borderColor: theme.palette.background.main,
        backgroundColor: theme.palette.border.dark,
    },
    timelineTop: {
        height: 22,
        width: 1,
        backgroundColor: theme.palette.border.main,
    },
    timelineContainer: {
        ...StyleSheet.absoluteFillObject,
        // backgroundColor: 'pink',
    },
    timelineBottom: {
        width: 1,
        backgroundColor: theme.palette.border.main,
    },
}));
export default EFView;
